import { useState, useEffect } from 'react';

export const useHydration = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    // Esperar a que zustand termine de hidratar desde localStorage
    const timer = setTimeout(() => {
      setHydrated(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return hydrated;
}; 